import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../../components/SparkleEffect';
import { ClipboardListIcon, PaletteIcon, FileTextIcon, LockIcon, ArrowLeftIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
export function SelfCareListsPage() {
  const checklists = [{
    name: 'Morning Routine Reset',
    price: '$2.99',
    description: "Build a morning that doesn't start with doom-scrolling. A step-by-step checklist to create a routine that actually sets you up for the day.",
    includes: ['Free Interactive Checklist', 'Printable PDF'],
    link: '',
    accent: 'from-sky-100/40 to-white/30',
    borderColor: 'border-sky-200/50',
    icon: '☀️',
    comingSoon: true
  }, {
    name: 'Ultimate Glow-Up Guide',
    price: '$2.99',
    description: 'Your step-by-step checklist for a full mind, body, and soul reset.',
    includes: ['Free Interactive Checklist', 'Printable PDF'],
    link: '',
    accent: 'from-blush-100/40 to-lavender-100/30',
    borderColor: 'border-blush-200/50',
    icon: '✨',
    comingSoon: true
  }];
  return <div className="min-h-screen pt-24 pb-24 relative" data-id="element-1991" data-mp="3dhnhjvqtke38">
      <img src="https://cdn.magicpatterns.com/uploads/oG4RFfihdYAxazP48DHh8y/ChatGPT_Image_Mar_21,_2026,_09_37_08_PM.png" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-contain object-top pointer-events-none z-0" data-id="element-1992" data-mp="3df0z312e4e68" />
      <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white/70 z-0" data-id="element-1993" data-mp="3ig8813g9rjeh" />

      <section className="relative py-12 text-center overflow-hidden" data-id="element-1994" data-mp="1pgnfsglnqo">
        <SparkleEffect count={50} data-id="element-1995" data-mp="3s7cpc9tf3gch" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-1996" data-mp="3s8e7szcrj548">
          <div className="mb-8 flex justify-center" data-id="element-1997" data-mp="a1gf1sk54mw1">
            <Link to="/checklists" className="inline-flex items-center gap-2 text-plum-500 hover:text-cta-500 font-bold transition-colors" data-id="element-1998" data-mp="51lq3ujxe7dm">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-1999" data-mp="2yrh1n228e8h7" />
              Back to Categories
            </Link>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/40 backdrop-blur-sm border border-blush-200/50 text-sm font-bold text-plum-700 mb-6 uppercase tracking-wider" data-id="element-2000" data-mp="37u89yszt8o4m">
            <ClipboardListIcon className="w-4 h-4 text-cta-500" data-id="element-2001" data-mp="3qkq0cqx677mt" />
            Category
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-2002" data-mp="3vkcgb84dv1zb">
            Self-Care & <span className="text-cta-500" data-id="element-2003" data-mp="1to3kp2wzrau0">Glow-Up</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl text-plum-500 font-medium max-w-2xl mx-auto" data-id="element-2004" data-mp="1ou9448conbz5">
            Because you deserve to feel good. Routines and resets for your mind
            and body.
          </motion.p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 mb-12" data-id="element-2005" data-mp="22ldwcpdq11zg">
        {/* Free Interactive Checklist */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-pink-50 to-purple-50 backdrop-blur-sm border-2 border-pink-200 rounded-[2rem] p-8 shadow-md mb-10" data-id="element-2006" data-mp="1ynq0nk47f56i">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-2007" data-mp="2fvfryaco9yqg">
            <div className="text-5xl" data-id="element-2008" data-mp="216bawwhm60jx">🧖‍♀️</div>
            <div className="flex-grow text-center md:text-left" data-id="element-2009" data-mp="263jrwtr0zyjl">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-pink-500 text-white text-xs font-bold mb-3 uppercase tracking-wider" data-id="element-2010" data-mp="261ql9egexebl">
                <SparklesIcon className="w-3 h-3" data-id="element-2011" data-mp="2yrfmnsx1bgdq" />
                Free Interactive Checklist
              </div>
              <h3 className="font-heading text-2xl font-bold text-pink-800 mb-2" data-id="element-2012" data-mp="2krxtz2gmbiz3">
                Daily Self-Care & Hygiene Ritual
              </h3>
              <p className="text-pink-600 font-medium" data-id="element-2013" data-mp="19dkae9swdpov">
                Your daily hygiene & wellness ritual — shower, skincare,
                hydration, movement, and mindful moments. Track your self-care
                every day!
              </p>
            </div>
            <Link to="/free-resources/self-care/daily" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-pink-500 text-white font-bold text-sm hover:bg-pink-600 transition-colors shadow-lg shadow-pink-500/20 shrink-0" data-id="element-2014" data-mp="15ts97hr7d28o">
              Try It Free
              <ArrowRightIcon className="w-4 h-4" data-id="element-2015" data-mp="1asmxgz7xvj06" />
            </Link>
          </div>
        </motion.div>

        <h2 className="font-heading text-2xl font-bold text-plum-700 mb-6 text-center" data-id="element-2016" data-mp="n2snqqix2ak5">
          Premium Checklists
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2017" data-mp="wvgjrj22oaht">
          {checklists.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`relative bg-gradient-to-br ${item.accent} backdrop-blur-sm ${item.borderColor} border rounded-[2rem] p-6 shadow-sm opacity-75 transition-all duration-300 flex flex-col`} data-id="element-2018" data-mp="s36v06cp1gh4" data-mpi={i}>
              <div className="absolute top-4 right-4 px-3 py-1 bg-white/80 text-plum-500 text-xs font-bold rounded-full uppercase tracking-wider flex items-center gap-1 border border-plum-100" data-id="element-2019" data-mp="12u1r98by6mom">
                <LockIcon className="w-3 h-3" data-id="element-2020" data-mp="a5nv6y4f60fp" /> Coming Soon
              </div>

              <div className="text-4xl mb-4" data-id="element-2021" data-mp="f5se0ussv793">{item.icon}</div>

              <h3 className="font-heading text-lg font-bold text-plum-700 mb-2 leading-snug" data-id="element-2022" data-mp="f7liq4jurheg">
                {item.name}
              </h3>

              <p className="text-plum-500 text-sm font-medium mb-4 flex-grow" data-id="element-2023" data-mp="1ql78nrxjdn11">
                {item.description}
              </p>

              <div className="space-y-2 mb-5" data-id="element-2024" data-mp="1vih880en3f2l">
                {item.includes.map((inc, j) => <div key={j} className="flex items-center gap-2 text-xs font-bold text-plum-600" data-id="element-2025" data-mp="3g0hz1yrmalvf" data-mpi={j}>
                    {j === 0 ? <PaletteIcon className="w-3.5 h-3.5 text-cta-500 shrink-0" data-id="element-2026" data-mp="36aovnl1mpd29" /> : <FileTextIcon className="w-3.5 h-3.5 text-cta-500 shrink-0" data-id="element-2027" data-mp="31cdltabc32k1" />}
                    {inc}
                  </div>)}
              </div>

              <div className="flex items-center justify-between mt-auto pt-4 border-t border-plum-100/30" data-id="element-2028" data-mp="2sbfdiftv48vn">
                <span className="font-heading text-2xl font-bold text-plum-700" data-id="element-2029" data-mp="2ndnn5q8v8utk">
                  {item.price}
                </span>
                <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-plum-200/50 text-plum-500 font-bold text-xs" data-id="element-2030" data-mp="llsg5nxk1eho">
                  <LockIcon className="w-3 h-3" data-id="element-2031" data-mp="gnqyn7fs1n8b" />
                  Soon
                </span>
              </div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}